import { deserialize, fetchWrapper } from '../fetch';
import type { UserEvent } from './interface';

export const addUserEvent = async (userEvent: UserEvent): Promise<number> => {
  const url = new URL('/app/v1/user_events', API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userEvent),
    })
  );
};
